import Icon from '../Icon.vue'

Icon.register({
  'doc': {
    width: 21,
    height: 20,
    paths: [
      {
        d: 'M10 5V2.824L12.176 5H10zm.003-5H1a1 1 0 00-1 1v18a1 1 0 001 1h13a1 1 0 001-1v-3h-2v2H2V2h6v4a1 1 0 001 1h4v2h2V4.997L10.003 0z'
      },
      {
        d: 'M9.976 11.398c-.111-.168-.28-.28-.588-.28h-.54v2.801h.54c.308 0 .477-.112.588-.28.099-.139.134-.272.134-1.12 0-.84-.035-.98-.134-1.12zm.84 3.124c-.342.343-.825.49-1.344.49h-1.85v-4.986h1.85c.519 0 1.002.146 1.345.49.58.581.518 1.22.518 2.003 0 .784.063 1.422-.518 2.003zM14.267 11.294a.614.614 0 00-.49-.218c-.224 0-.4.099-.49.218-.113.146-.182.314-.182 1.226 0 .91.069 1.07.182 1.218.09.119.266.224.49.224a.617.617 0 00.49-.224c.112-.147.183-.308.183-1.218 0-.912-.071-1.08-.183-1.226zm.903 3.2c-.363.364-.784.56-1.393.56-.61 0-1.03-.196-1.394-.56-.525-.525-.504-1.225-.504-1.974 0-.75-.021-1.451.504-1.976.364-.364.784-.56 1.394-.56.609 0 1.03.196 1.393.56.526.525.505 1.226.505 1.976 0 .749.02 1.449-.505 1.974zM18.11 15.055c-.582 0-1.023-.196-1.388-.561-.525-.525-.504-1.225-.504-1.974 0-.75-.02-1.45.504-1.976.365-.364.806-.56 1.387-.56.945 0 1.71.525 1.891 1.625h-1.246c-.078-.28-.232-.533-.638-.533-.224 0-.392.092-.484.21-.11.148-.188.323-.188 1.234 0 .91.077 1.085.188 1.232.092.119.26.21.484.21.406 0 .56-.252.638-.532H20c-.182 1.1-.946 1.625-1.89 1.625z'
      }
    ]
  }
})
